/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdatePersonNotificationInput = {
    ids?: Array<string | null> | null | undefined;
    publisherPersonId?: number | null | undefined;
    subscriberPersonId?: number | null | undefined;
    entityType?: string | null | undefined;
    entityId?: number | null | undefined;
    publisherAction?: string | null | undefined;
    params?: string | null | undefined;
    createdAt?: string | null | undefined;
    all?: boolean | null | undefined;
    read?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updatePersonNotificationMutationVariables = {
    input: UpdatePersonNotificationInput;
};
export type updatePersonNotificationMutationResponse = {
    readonly updatePersonNotification: {
        readonly viewer: {
            readonly recentNotifications: ReadonlyArray<{
                readonly id: string;
                readonly countId: number | null;
                readonly publisherPersonId: string;
                readonly subscriberPersonId: string;
                readonly publisherAction: string | null;
                readonly entityType: string | null;
                readonly entityId: number | null;
                readonly params: string | null;
                readonly createdAt: string | null;
                readonly read: boolean | null;
            } | null> | null;
            readonly unseenNotifications: number | null;
        } | null;
        readonly PersonNotifications: ReadonlyArray<{
            readonly id: string;
            readonly read: boolean | null;
        } | null> | null;
    } | null;
};
export type updatePersonNotificationMutation = {
    readonly response: updatePersonNotificationMutationResponse;
    readonly variables: updatePersonNotificationMutationVariables;
};



/*
mutation updatePersonNotificationMutation(
  $input: UpdatePersonNotificationInput!
) {
  updatePersonNotification(input: $input) {
    viewer {
      recentNotifications {
        id
        countId
        publisherPersonId
        subscriberPersonId
        publisherAction
        entityType
        entityId
        params
        createdAt
        read
      }
      unseenNotifications
      id
    }
    PersonNotifications {
      id
      read
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePersonNotificationInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "read",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "PersonNotification",
  "kind": "LinkedField",
  "name": "recentNotifications",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publisherPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subscriberPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publisherAction",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "params",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unseenNotifications",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "PersonNotification",
  "kind": "LinkedField",
  "name": "PersonNotifications",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePersonNotificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePersonNotificationPayload",
        "kind": "LinkedField",
        "name": "updatePersonNotification",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePersonNotificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePersonNotificationPayload",
        "kind": "LinkedField",
        "name": "updatePersonNotification",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updatePersonNotificationMutation",
    "operationKind": "mutation",
    "text": "mutation updatePersonNotificationMutation(\n  $input: UpdatePersonNotificationInput!\n) {\n  updatePersonNotification(input: $input) {\n    viewer {\n      recentNotifications {\n        id\n        countId\n        publisherPersonId\n        subscriberPersonId\n        publisherAction\n        entityType\n        entityId\n        params\n        createdAt\n        read\n      }\n      unseenNotifications\n      id\n    }\n    PersonNotifications {\n      id\n      read\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '06eb7d55a2632c6f93e61cdfc91cf0b3';
export default node;
